

























































































import Vue from 'vue'
import VueSimpleSpinner from 'vue-simple-spinner'

import Alert from '@/main/alert.vue'

import { Config } from '@/config'
import Component from 'vue-class-component'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { Injector } from '@/config/dependency-injection'
import { loggerFor } from '@/shared/utils/logger'
import { AuthenticationService } from '@/authentication/authentication-service'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'
import { Anonymous } from '@/authentication/models/Anonymous'
import { NotificationService } from '@/shared/services/notification-service'
import { TranslateService } from '@/shared/services/translate-service'
import { Prop } from 'vue-property-decorator'
import { MetaService } from '@/shared/services/meta-service'

@Component({
  components: {
    Alert,
    UnifyButton,
    VueSimpleSpinner,
  },
})
export default class Login extends Vue {
  @Prop({
    default: () => '',
    required: false,
    type: String,
  })
  public readonly username!: string

  private logger = loggerFor('Login')

  private authenticationService: AuthenticationService = Injector.get(AuthenticationService)
  private metaService = Injector.get(MetaService)
  private notificationService: NotificationService = Injector.get(NotificationService)
  private router = Injector.get<VueRouter>(RouterToken)
  private translateService = Injector.get(TranslateService)

  private error?: any = null
  private showAlert = false
  private user = ''
  private password = ''

  public created() {
    this.metaService.updateDocumentTitle('login')

    const route: string = (this.router.currentRoute.query.route as string) || Config.defaultRoute

    if (this.authenticationService.authenticatedUser() !== Anonymous) {
      this.router.push(route)
    }

    this.user = this.username
  }

  public login() {
    this.authenticationService
      .login({
        password: this.password,
        username: this.user,
      })
      .then(account => {
        const route = (this.router.currentRoute.query.route as string) || {
          name: 'organisation-about',
          params: {
            id: String(account.organisation.id),
          },
        }

        this.notificationService.success('login.success', 'far fa-check', {
          text: this.translateService.translate('menu.myOffers'),
          onClick: () => {
            this.router.push({
              name: 'organisation-offers',
              params: {
                id: String(account.organisation.id),
              },
            })
          },
        })

        this.router.push(route)
      })
      .catch(() => {
        this.error = this.$t('login.error')
        this.showAlert = true
      })
  }
}
